import { Button, Table, Tag } from "antd";
import React from "react";
import { Card, CardBody } from "reactstrap";
import {
  fetchInventoryItems,
  fetchInventorySubCategories,
} from "../../../../../api/inventory.api";
import styles from "./styles.module.scss";
import AddCategoryDialog from "./form";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

const taxTypeValues = {
  cgst_sgst: "SGST/CGST",
  igst: "IGST",
};

const InventoryItems = () => {
  const [items, setItems] = React.useState([]);
  const [showItemsDrawer, setShowItemsDrawer] = React.useState(false);
  const [subCategories, setSubCategories] = React.useState([]);
  const [editItem, setEditItem] = React.useState(null);

  const getCategories = React.useCallback(async () => {
    try {
      const items = await fetchInventoryItems();
      setItems(
        items.sort((a, b) => {
          return a.id - b.id;
        })
      );
    } catch (error) {
      console.log(error);
    }
  }, []);

  const getSubCategories = React.useCallback(async () => {
    try {
      const subCategories = await fetchInventorySubCategories();
      setSubCategories(subCategories);
    } catch (error) {
      console.log(error);
    }
  }, []);

  React.useEffect(() => {
    getCategories();
  }, [getCategories]);

  React.useEffect(() => {
    getSubCategories();
  }, [getSubCategories]);

  const tableColumns = React.useMemo(() => {
    const columns = [
      {
        key: "id",
        title: "S. No.",
        dataIndex: "id",
      },
      {
        key: "product_name",
        title: "Product Name",
        dataIndex: "product_name",
      },
      {
        key: "inventory_subcategory",
        title: "Subcategory Name",
        render: (item) => {
          return subCategories.find(
            (subCategory) => subCategory.id === item.inventory_subcategory
          )?.subcategory_name;
        },
      },
      {
        key: "unit",
        title: "Unit",
        dataIndex: "unit",
      },
      {
        key: "cost_price",
        title: "Cost Price",
        dataIndex: "cost_price",
      },
      {
        key: "selling_price",
        title: "Selling Price",
        dataIndex: "selling_price",
      },
      {
        key: "tax_value",
        title: "Tax Value",
        dataIndex: "tax_value",
      },
      {
        key: "tax_type",
        title: "Tax Type",
        render: (item) => {
          return taxTypeValues[item.tax_type];
        },
      },
      {
        key: "stock",
        title: "Stock",
        dataIndex: "stock",
      },
      {
        key: "discount",
        title: "Discount",
        dataIndex: "discount",
      },
      {
        key: "hsn_code",
        title: "HSN Code",
        dataIndex: "hsn_code",
      },
      {
        key: "actions",
        title: "Actions",
        render: (item) => {
          return (
            <div className={styles.actions}>
              <Tag
                color="blue"
                onClick={() => {
                  setEditItem(item);
                  setShowItemsDrawer(true);
                }}
              >
                <EditOutlined />
              </Tag>
              <Tag color="red">
                <DeleteOutlined />
              </Tag>
            </div>
          );
        },
      },
    ];

    return columns;
  }, [subCategories]);

  return (
    <div className={styles.container}>
      <AddCategoryDialog
        onClose={() => {
          setShowItemsDrawer(false);
          setEditItem(null);
        }}
        open={showItemsDrawer}
        refresh={getCategories}
        edit={Boolean(editItem)}
        item={editItem}
      />
      <div>
        <Card>
          <CardBody>
            <div className={styles.header}>
              <h5>Items</h5>
              <div className={styles.actions}>
                <Button type="primary" onClick={() => setShowItemsDrawer(true)}>
                  Add Item
                </Button>
              </div>
            </div>
            <div className={styles.categories}>
              <Table
                columns={tableColumns}
                dataSource={items}
                pagination={{
                  defaultPageSize: 10,
                  showSizeChanger: true,
                }}
              />
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default InventoryItems;
